import { render } from "./WirelessAP.vue?vue&type=template&id=06b03961"
import script from "./WirelessAP.vue?vue&type=script&lang=js"
export * from "./WirelessAP.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/WJ-WEB/htweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__